import FarmerRegistryModule from '@abaco/farm-registry/src/modules/farm-registry';
import DashboardRegistryModule from '@abaco/dashboard-module/src/modules/dashboard'
import GlobalState from "@abaco/portal-global-state/src/modules/global-state/index";
import { AbacoWebModule, ApplicationReadyEvent, MenuItem, RouterReadyEvent, VueRouter } from '@abaco/web-common/src/app';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import LivestocksCountingApi from './api/LivestocksCounting';
import globals from "./globals";
import { createMenu } from './menu';
import myRoutes from "./routes";
import LivestocksCounting from './state';

export const MODULE_ID = "livestocksCounting";

export default class LivestocksCountingModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private lscApi!: LivestocksCountingApi;
    private apiCreated = false;

    private router!: VueRouter;
    private http!: HTTPClient;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = new LivestocksCounting();
    menu: MenuItem[] = [];

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient){
        if(this.apiCreated){
            return;
        }
        this.apiCreated = true;
        const LivestocksCountingApi = (await import("./api/LivestocksCounting")).default;
        this.lscApi = new LivestocksCountingApi(http);
    }

    public get livestocksCountingApi(){
        return this.lscApi;
    }

    dependsOn = {
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [DashboardRegistryModule.MODULE_ID]: () => new DashboardRegistryModule(),
        [GlobalState.MODULE_ID]: () => new GlobalState(),
    }

}
